import React, { useRef, useEffect } from "react";
import Hls from "hls.js";
import classNames from "classnames/bind";

const ReactPlayer = ({
  url,
  controls,
  pointX = 0,
  pointY = 0,
  scale = 1,
  height = "100%",
}) => {
  const ref = useRef(null);
  useEffect(() => {
    let hls;

    if (Hls.isSupported()) {
      hls = new Hls({
        debug: true, // Bật debug mode (tuỳ chọn)
        enableWorker: true, // Sử dụng Web Workers để tối ưu
        lowLatencyMode: true, // Kích hoạt chế độ độ trễ thấp
        maxBufferSize: 20 * 1000 * 1000,
        // Kích thước buffer tối đa (20MB)
      });

      hls.loadSource(url); // Load URL của HLS stream
      hls.attachMedia(ref.current); // Gắn hls vào thẻ video

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("HLS manifest loaded");
        ref.current.play(); // Tự động phát video sau khi load xong manifest
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js error:", data);
      });
    } else if (ref.current.canPlayType("application/vnd.apple.mpegurl")) {
      // Trường hợp HLS được hỗ trợ gốc bởi trình duyệt (Safari)
      ref.current.src = url;
    }

    // Dọn dẹp khi component bị hủy
    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [url]);
  return (
    <video
      ref={ref}
      controls={controls}
      style={{
        width: "100%",
        height: height,
        objectFit: "fill",
        transformOrigin: "0 0",
        transform: `translate(${pointX}px,${pointY}px) scale(${scale})`,
        transition: "transform 0.2s",
        display:"block",
        aspectRatio:"16/9"
      }}
    />
  );
};

export default ReactPlayer;
